import { render, staticRenderFns } from "./CreationSettingFacebookForm.vue?vue&type=template&id=2072ceb8&"
import script from "./CreationSettingFacebookForm.vue?vue&type=script&lang=js&"
export * from "./CreationSettingFacebookForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports